import React, { useEffect, useRef } from "react";
// import "bootstrap/js/dist/collapse";

import square from "../assets/images/square.svg";
import SEO from "components/SEO";

const questionBank = [
  {
    question: "What is GangstaBet?",
    answer:
      "GangstaBet is a collection of 5,555 customizable Gangster and Detective-themed NFTs on the ICON blockchain. Each GangstaBet has a unique appearance and a class with corresponding skills and ranks. There will ever be 5,555 GangstaBets created.",
    id: "questionOne",
  },
  {
    question: "What inspired you to create GangstaBet?",
    answer:
      "Our inspiration for the project is ICONBet (the most popular DApp in ICON), Hashmasks (the first digital collectible with a name-changing token), and Gangster movie films such as Peaky Blinders, The Untouchables, and Capone. We combined all of their concepts to create an engaging & participatory digital collective, which can stand out & be an exemplary NFT project in the ICON community. The 8-bit design was inspired by the legendary NFT project CryptoPunks.",
    id: "questionTwo",
  },
  {
    question: "Why ICON blockchain and not Ethereum?",
    answer:
      "ICON has several advantages over other blockchains which encouraged us to launch GangstaBet. Most importantly, low transaction fees, faster block time & an inclusive community. Blockchain Transmission Protocol (BTP), which allows multi-chain asset transfer, is something we are extremely excited about. More importantly, there are many interesting projects being launched in ICON and the community is thriving.",
    id: "questionThree",
  },
  {
    question: "What's so special about the characters?",
    answer:
      "Each character is unique with varying teams, classes, and appearances. These are extrinsic properties that will make them valuable based on their rarity. Characters will either become gangsters or detectives. Within each team, there will be a variety of classes with specific skills. For example, gangsters are assigned a class like Pokerstar, Marksman, Rumrunner, and Detectives are assigned classes like Commander, Brains, and Brute. Their rarity will vary too. Each class will have five skills, with three skills as core to the type of GangstaBet (Gangster or Detective) and the other two will be determined by the class. For example, The Pokerstar will have the skills of Racketeering, Shooting, Gambling, Intelligence and Strategy. In addition, every GangstaBet’s appearance will vary greatly. Characters may be female, male, have red hair, a suit, trench coat, drinking a beer or shooting a gun! As well, the background of every character will be different. Some characters may have a background of a specific color, some may have a playing card and others could have a martini! All of these features will vary in rarity.",
    id: "questionFour",
  },
  {
    question: "How did you create the art?",
    answer:
      "Each GangstaBet is unique and programmatically generated from thousands of files. The process was long and meticulously done. We are very happy with the final GangstaBets.",
    id: "questionFour",
  },
  {
    question: "Are all GangstaBets unique?",
    answer: "Yes, no two GangstaBets can have the same visual or skills.",
    id: "questionFive",
  },
  {
    question: "What are ranks in GangstaBet?",
    answer:
      "Every GangstaBet is either a Gangster or Detective. They start with Level 1 but can level up as you increase their skills. The types of levels for Gangsters and Detectives are different. Gangster: Casino Worker, Moonshiner, Smuggler,  Body Guard, Associate, Soldier, Captain, Underboss, Right-hand Person, Mob Boss & Detectives: Junior Detective, Detective Constable, Detective Sergeant, Detective Inspector, Detective Chief Inspector, Detective Superintendent, Detective Chief Superintendent, Assistant Chief Constable, Deputy Chief Constable, Chief Constable.",
    id: "questionFive",
  },
  {
    question: "What are classes in GangstaBet?",
    answer:
      "GangstaBets will be randomly assigned (on-chain) a class when they are created. Gangsters can be of one of the 5 classes (Pokerstar, Rumrunner, Commander, Brute & Marksman) whereas Detectives can be one of the 4 classes (Commander, Brains, Investigator, Brute). Their classes determine the type of skills that they have. Classes are permanent and cannot be changed.",
    id: "questionFive",
  },
  {
    question: "How does naming work?",
    answer:
      "You can change the name of your GangstaBet by using $GBET tokens. The names can have alphanumeric characters and have a maximum character length of 25. The names have to be unique, which means that no two characters can ever share the same name. As Gangsters usually stick with their names throughout their career, it gets more expensive the more you change their name.",
    id: "questionFive",
  },
  {
    question: "I'm sold! When can I buy GangstaBets?",
    answer:
      "We intend to start the pre-sale at the end of September, 2021. But for now, you can reserve them.",
    id: "questionFour",
  },
  {
    question: "How can I buy it? How do I get ICX?",
    answer:
      "Ideally, you will need a wallet (we recommend either ICONex browser extension or hardware Ledger) to interact with the GangstaBet platform. We recommend you install it before the pre-sale. GangstaBet NFTs can be bought with only ICX cryptocurrency. You can get them in popular exchanges like Binance, Kraken, Crypto.com, OKEx, Gate.io, etc.",
    id: "questionFour",
  },
  {
    question: "Which GangstaBets will be the most valuable?",
    answer:
      "There are many layers of rarity including visual properties, names & skills. The ones with the most creative name & highest skills could be the determining factor. But only time will tell.",
    id: "questionFour",
  },
];

const QuestionBlock = ({ question, children, id }) => {
  const body = useRef(null);
  const handleOpen = () => {
    body.current.classList.toggle("active");
  };
  return (
    <div className="accordion-item" onClick={handleOpen} key={id}>
      <h2 className="accordion-title" id={`flush-headingOne${id}`}>
        {/* <button
          className="button accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#flush-collapseOne${id}`}
          aria-expanded="false"
          aria-controls={`flush-collapseOne${id}`}
        > */}
        <p className="w-100 mb-0">Q. {question}</p>
        {/* </button> */}
      </h2>
      {/* <div
        id={`flush-collapseOne${id}`}
        className="accordion-collapse collapse"
        aria-labelledby={`flush-headingOne${id}`}
        data-bs-parent={`#${id}`}
      > */}
      <div className="accordion-body active" ref={body}>
        {children}
      </div>
      {/* </div> */}
    </div>
  );
};

const FAQ = () => {
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);
  const pageMetaData = {
    pageTitle: `FAQ | GangstaBet: A Digital Collectible  `,
    pageDescription: null,
    pageKeywords: null,
    pageImage: null,
  };
  return (
    <SEO pageMetaData={pageMetaData}>
      <div className="faq position-relative">
        <p className="title">Frequently Asked Questions</p>
        <img src={square} alt="background" className="pattern" />
        <div className="accordion question-container">
          {questionBank.map((item, index) => (
            <QuestionBlock key={index} question={item.question} id={item.id}>
              {item.answer}
            </QuestionBlock>
          ))}
        </div>
        <div className="further-inquire py-4">
          <h4 className="info-title mb-2">Still have a questions?</h4>

          <p className="information">
            If you can not find the answers to your question, you can always
            contact us.
          </p>
          <a target="_blank" href="https://t.me/gangstabet_icon">
            <button className="btn rounded-pill">CONTACT US</button>
          </a>
        </div>
      </div>
    </SEO>
  );
};

export default FAQ;
